import { render, staticRenderFns } from "./AllQuestionAnswers.vue?vue&type=template&id=105be70a&scoped=true&"
import script from "./AllQuestionAnswers.vue?vue&type=script&lang=js&"
export * from "./AllQuestionAnswers.vue?vue&type=script&lang=js&"
import style0 from "./AllQuestionAnswers.vue?vue&type=style&index=0&id=105be70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105be70a",
  null
  
)

export default component.exports